export default __webpack_public_path__ + "67376c7e1f1575e72d7f653eca76c51d.svg";